import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { MailsAccountsRoutingModule } from './mails-accounts-routing.module';
import { DragDropModule } from 'primeng/dragdrop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FileUploadModule } from 'primeng/fileupload';
import { AccordionModule } from 'primeng/accordion';
import { MailsAccountListComponent } from './mails-account-list/mails-account-list.component';
import { MailsAccountDetailComponent } from './mails-account-detail/mails-account-detail.component';
import { MailsAccountListMailboxesComponent } from './mails-account-list-mailboxes/mails-account-list-mailboxes.component';


import { TooltipModule } from 'primeng/tooltip';
import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        MailsAccountListComponent,
        MailsAccountDetailComponent,
        MailsAccountListMailboxesComponent
    ], imports: [CoreModule,
        TooltipModule,
        MailsAccountsRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        AccordionModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        DragDropModule,
        BrowserAnimationsModule,
        FileUploadModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MailsAccountsModule { }
